// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"859":"css/admin-app.7018","5685":"css/app.7018"}[chunkId] + ".css";
};